<template>
  <transition name="slide-fade">
    <div
      v-if="field_visible && can_show"
      :class="{ design_mode: design, conditionalWidget: true }"
    >
      <f-widget-list
        :fields="field.fields"
        :form-state="formState"
        :form-context="nestedFormContext"
        :item="the_item[field.code]"
        :design="design"
        :disabled="is_disabled"
        :selector="selector"
        @change="change"
        @error="handleError"
        @fields-change="fieldsChanged"
      ></f-widget-list>
    </div>
  </transition>
</template>

<script>
import { setter } from "../setter";
import { prepareExpression } from "../../../vue-ocom/query/expression.js";
import FWidgetList from "../FWidgetList.vue";
import ContainerWidgetMixin from "../ContainerWidgetMixin.js";
import { ParseProvider } from "../../utils/parse";

export default {
  name: "ConditionalWidget",
  mixins: [ContainerWidgetMixin],
  components: { FWidgetList },
  computed: {
    can_show() {
      if (this.design) {
        return true;
      }

      try {
        const expr_function = this.expression_function;
        if (expr_function != null) {
          return expr_function(this.item);
        }
      } catch (ex) {
        console.error(ex);
        return false; // error..
      }
      return false; // if were are here dont show
    },
    expression_function() {
      if (this.field.params.expression) {
        const $provider = ParseProvider();
        var filters = {};
        var $parser = $provider.$get(filters);
        return $parser(this.field.params.expression);
      } else {
        var target_field = this.field.params.field;
        var item_field = this.the_item[this.field.params.field];

        // Check if the item_field is an object or not!
        if (item_field != null) {
          if (typeof item_field === "object" && item_field.val !== undefined) {
            // The item_field is an Object with a val use that instead
            target_field = this.field.params.field + ".val";
          }
        }

        return prepareExpression([
          target_field,
          this.field.params.comparison,
          this.field.params.match_value,
        ]).evaluate;
      }
    },
  },
  methods: {
    on_input: function (value) {
      if (!this.is_disabled) {
        var item = this.item || {};

        var val = item[this.field.code];
        if (!val) {
          val = {};
        }

        setter(this, val, "__visible", this.can_show); // store if visible - for backwards compatiblity
        setter(this, val, "val", this.can_show); // store if visible in val also

        console.log("conditional.on_input", this.field.code, val);

        this.change(val);
      }
    },
  },
  watch: {
    can_show: function (value) {
      this.on_input(value); // store the value.
    },
  },
  created: function () {
    // if (this.item && !(this.field.code in this.item)) {
    //   setter(this, this.item, this.field.code, {});
    // }
  },
};
</script>

<style>
.slide-fade-enter-active {
  transition: all 0.3s ease;
}

.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}

.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateX(10px);
  opacity: 0;
}
</style>

<style scoped>
.design_mode {
  border: #b1b1b1 4px dotted;
  min-height: 100px;
}

.conditionalWidget {
}
</style>
